export enum DeviceVariantType {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

export enum Orientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export type UseScreenReturnType = {
  screen: DeviceVariantType;
  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;
  orientation?: Orientation;
};
